import type React from "react";
import styles from "./TrustedBy.module.scss";
import { LandingPageLayout } from "./LandingPageLayout";
import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";

interface Logo {
	id: string;
	src: string;
	alt: string;
	name: string;
}

interface TrustedByProps {
	logos: Logo[];
	heading?: string;
	subheading?: string;
}

const TrustedBy: React.FC<TrustedByProps> = ({ logos, heading = "Trusted By:", subheading = "Powering Homes and Businesses across Africa" }) => {
     const currentScreen: CurrentScreen = useWindowDimensions();
	const duplicateLogos = (originalLogos: Logo[], minCount = 8) => {
		if (originalLogos.length === 0) return [];

		const duplicated: Logo[] = [];
		let currentIndex = 0;

		// Create enough duplicates to ensure smooth scrolling
		for (let i = 0; i < minCount; i++) {
			duplicated.push({
				...originalLogos[currentIndex],
				id: `${originalLogos[currentIndex].id}-${i}`,
			});
			currentIndex = (currentIndex + 1) % originalLogos.length;
		}

		return duplicated;
	};

	const duplicatedLogos = duplicateLogos(logos);
	const width = currentScreen.width;

	return (
		<LandingPageLayout title="Trusted By:" subtitle="Powering Homes and Businesses across Africa" showMenu={false} className={styles.trustedSection}>
			<div className={styles.scrollContainer} style={{ width: width - 400 }}>
				<div className={styles.scrollTrack}>
					{duplicatedLogos.map(logo => (
						<div key={logo.id} className={styles.logoItem}>
							<img src={logo.src || "/placeholder.svg"} alt={logo.alt} title={logo.name} loading="lazy" />
						</div>
					))}
				</div>
			</div>
		</LandingPageLayout>
	);
};

export default TrustedBy;
